module.exports = __webpack_public_path__ + "img/practical_procedures_skills.46f6379c.svg";